<div class="w-full border-b border-gray-200">
  <button class="statoLavori w-full flex items-center justify-between p-3 text-left" (click)="toggleAccordion()">
    <div class="flex items-center gap-2">
      <div class="bg-primary bg-opacity-10 rounded-circle d-flex justify-content-center align-items-center">
        <i class="fa-solid fa-earth-europe text-primary"></i>
      </div>
      <span class="font-bold uppercase text-sm"> Tutti i cantieri - vista globale </span>
    </div>

    <i class="fa-solid fa-chevron-down transition-transform duration-300" [class.rotate-180]="isAccordionOpen"></i>
  </button>

  <div class="transition-[max-height] duration-300 ease-in-out"
    [ngStyle]="{ 'max-height': isAccordionOpen ? '2000px' : '0px' }">
    <div>
      @if (
      (selectedRegionUi && selectedRegionUi.length > 0) ||
      (selectedProvinceUi && selectedProvinceUi.length > 0) ||
      (selectedEnteUi && selectedEnteUi.length > 0) ||
      (selectedReteUi && selectedReteUi.length > 0) ||
      selectedPhase
      ) {
      <div class="w-full cardTutti p-3 flex flex-wrap gap-2 items-center">
        <span class="text-xs fw-bold text-uppercase me-1 text-gray-500">
          <i class="fa-solid fa-filter"></i> Filtri attivi:
        </span>

        <!-- REGIONI -->
        @if (selectedRegionUi && selectedRegionUi.length > 0) {
        @if (selectedRegionUi.length <= 3) { @for (reg of selectedRegionUi; track reg.id) { <div class="filter-chip">
          <span>Reg: {{ reg.label }}</span>
          <i class="fa-solid fa-times" title="Rimuovi" (click)="removeRegion(reg)"></i>
      </div>
      }
      } @else {
      <div class="chip-dropdown-wrapper">
        <div class="filter-chip filter-chip-more" (click)="toggleRegionsDropdown($event)">
          <i class="fa-solid fa-map-location-dot me-1"></i>
          <span>{{ selectedRegionUi.length }} Regioni</span>
          @if (showAllRegions) { <i class="fa-solid fa-chevron-up ms-1"></i> }
          @else { <i class="fa-solid fa-chevron-down ms-1"></i> }
        </div>

        @if (showAllRegions) {
        <div class="dropdown-panel">
          <div class="dropdown-header">
            <div class="dropdown-title">
              <i class="fa-solid fa-map-location-dot"></i>
              <strong>Regioni</strong>
              <span class="count-badge">{{ selectedRegionUi.length }}</span>
            </div>
            <button type="button" class="btn-close-dropdown" (click)="toggleRegionsDropdown($event)">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>

          <div class="dropdown-body">
            @for (reg of selectedRegionUi; track reg.id) {
            <div class="dropdown-item">
              <div class="item-content">
                <span>{{ reg.label }}</span>
              </div>
              <button type="button" class="btn-remove" (click)="removeRegion(reg); $event.stopPropagation()">
                <i class="fa-solid fa-times"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
      }

      <!-- PROVINCE -->
      @if (selectedProvinceUi && selectedProvinceUi.length > 0) {
      @if (selectedProvinceUi.length <= 3) { @for (prov of selectedProvinceUi; track prov.id) { <div
        class="filter-chip">
        <span>Prov: {{ prov.label }}</span>
        <i class="fa-solid fa-times" (click)="removeProvince(prov)"></i>
    </div>
    }
    } @else {
    <div class="chip-dropdown-wrapper">
      <div class="filter-chip filter-chip-more" (click)="toggleProvinceDropdown($event)">
        <i class="fa-solid fa-city me-1"></i>
        <span>{{ selectedProvinceUi.length }} Province</span>
        @if (showProvinceDropdown) { <i class="fa-solid fa-chevron-up ms-1"></i> }
        @else { <i class="fa-solid fa-chevron-down ms-1"></i> }
      </div>

      @if (showProvinceDropdown) {
      <div class="dropdown-panel">
        <div class="dropdown-header">
          <div class="dropdown-title">
            <i class="fa-solid fa-city"></i>
            <strong>Province</strong>
            <span class="count-badge">{{ selectedProvinceUi.length }}</span>
          </div>
          <button type="button" class="btn-close-dropdown" (click)="toggleProvinceDropdown($event)">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="dropdown-body">
          @for (prov of selectedProvinceUi; track prov.id) {
          <div class="dropdown-item">
            <div class="item-content">
              <span>{{ prov.label }}</span>
            </div>
            <button type="button" class="btn-remove" (click)="removeProvince(prov); $event.stopPropagation()">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
    }

    <!-- ENTI -->
    @if (selectedEnteUi && selectedEnteUi.length > 0) {
    @if (selectedEnteUi.length <= 3) { @for (e of selectedEnteUi; track e.id) { <div class="filter-chip">
      <span>Ente: {{ e.label }}</span>
      <i class="fa-solid fa-times" (click)="removeEnte(e)"></i>
  </div>
  }
  } @else {
  <div class="chip-dropdown-wrapper">
    <div class="filter-chip filter-chip-more" (click)="toggleEnteDropdown($event)">
      <i class="fa-solid fa-building me-1"></i>
      <span>{{ selectedEnteUi.length }} Enti</span>
      @if (showEnteDropdown) { <i class="fa-solid fa-chevron-up ms-1"></i> }
      @else { <i class="fa-solid fa-chevron-down ms-1"></i> }
    </div>

    @if (showEnteDropdown) {
    <div class="dropdown-panel">
      <div class="dropdown-header">
        <div class="dropdown-title">
          <i class="fa-solid fa-building"></i>
          <strong>Enti</strong>
          <span class="count-badge">{{ selectedEnteUi.length }}</span>
        </div>
        <button type="button" class="btn-close-dropdown" (click)="toggleEnteDropdown($event)">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <div class="dropdown-body">
        @for (e of selectedEnteUi; track e.id) {
        <div class="dropdown-item">
          <div class="item-content">
            <span>{{ e.label }}</span>
          </div>
          <button type="button" class="btn-remove" (click)="removeEnte(e); $event.stopPropagation()">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
  }

  <!-- RETI -->
  @if (selectedReteUi && selectedReteUi.length > 0) {
  @if (selectedReteUi.length <= 3) { @for (r of selectedReteUi; track r.id) { <div class="filter-chip">
    <span>Rete: {{ r.label }}</span>
    <i class="fa-solid fa-times" (click)="removeRete(r)"></i>
</div>
}
} @else {
<div class="chip-dropdown-wrapper">
  <div class="filter-chip filter-chip-more" (click)="toggleReteDropdown($event)">
    <i class="fa-solid fa-network-wired me-1"></i>
    <span>{{ selectedReteUi.length }} Reti</span>
    @if (showReteDropdown) { <i class="fa-solid fa-chevron-up ms-1"></i> }
    @else { <i class="fa-solid fa-chevron-down ms-1"></i> }
  </div>

  @if (showReteDropdown) {
  <div class="dropdown-panel">
    <div class="dropdown-header">
      <div class="dropdown-title">
        <i class="fa-solid fa-network-wired"></i>
        <strong>Reti</strong>
        <span class="count-badge">{{ selectedReteUi.length }}</span>
      </div>
      <button type="button" class="btn-close-dropdown" (click)="toggleReteDropdown($event)">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="dropdown-body">
      @for (r of selectedReteUi; track r.id) {
      <div class="dropdown-item">
        <div class="item-content">
          <span>{{ r.label }}</span>
        </div>
        <button type="button" class="btn-remove" (click)="removeRete(r); $event.stopPropagation()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      }
    </div>
  </div>
  }
</div>
}
}

<!-- FASE -->
@if (selectedPhase && selectedPhase !== '') {
<div class="filter-chip">
  <span>Fase: {{ selectedPhase.replace(/_/g, ' ') }}</span>
  <i class="fa-solid fa-times" (click)="removePhase()"></i>
</div>
}

<button class="btn-reset-filters" (click)="resetAll()">
  <i class="fa-solid fa-arrow-rotate-left"></i>
  Resetta filtri
</button>
</div>
}

<div>
  <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 p-2">
    <!-- Totale siti -->
    <div class="card p-2">
      <div class="card-intern d-flex align-items-center mb-2" (click)="toggleFilterByPhase('ALL')">
        <img src="assets/icons/totale siti.svg" alt="Totale siti" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ totalSites }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="uppercase text-gray-500 font-bold text-sm">Totale siti</small>
    </div>

    <!-- Da avviare -->
    <div class="card p-2" (click)="toggleFilterByPhase('DA_AVVIARE')">
      <div class="d-flex align-items-center mb-2">
        <img src="assets/icons/da avviare.svg" alt="Da avviare" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ daAvviare }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">Da avviare</small>
    </div>

    <!-- In progettazione -->
    <div class="card p-2">
      <div class="d-flex align-items-center mb-2" (click)="toggleFilterByPhase('IN_PROGETTAZIONE')">
        <img src="assets/icons/in progettazione.svg" alt="In progettazione" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ inProgettazione }} } @else { <i
            class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">In progettazione</small>
    </div>

    <!-- In esecuzione -->
    <div class="card p-2" (click)="toggleFilterByPhase('IN_ESECUZIONE')">
      <div class="d-flex align-items-center mb-2">
        <img src="assets/icons/in esecuzione.svg" alt="In esecuzione" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ inEsecuzione }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i>
          }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">In esecuzione</small>
    </div>

    <!-- In verifica -->
    <div class="card p-2" (click)="toggleFilterByPhase('IN_VERIFICA')">
      <div class="d-flex align-items-center mb-2">
        <img src="assets/icons/pronti al collaudo.svg" alt="Pronti al collaudo" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ inVerifica }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">In verifica</small>
    </div>

    <!-- Connessi -->
    <div class="card p-2" (click)="toggleFilterByPhase('CONNESSI')">
      <div class="d-flex align-items-center mb-2">
        <img src="assets/icons/fine lavori.svg" alt="Fine lavori" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ connessi }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">Connessi</small>
    </div>

    <!-- Collaudati -->
    <div class="card p-2" (click)="toggleFilterByPhase('COLLAUDATI')">
      <div class="d-flex align-items-center mb-2">
        <img src="assets/icons/collaudati.svg" alt="Collaudati" width="42" class="me-2" />
        <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
          @if (!isLoadingCards) { {{ collaudati }} } @else { <i class="fa-solid fa-spinner fa-spin text-gray-400"></i> }
        </h4>
      </div>
      <small class="m-0 uppercase text-gray-500 font-bold text-sm">Collaudati</small>
    </div>

    <!-- Criticità -->
    <div class="p-2 criticita" [class.dropdown-open]="isCriticitaOpen">
      <div class="d-flex align-items-center criticita-header mb-2" (click)="toggleCriticita($event)">
        <img src="assets/icons/criticità.svg" alt="Criticità" width="42" class="me-2" />

        <div class="d-flex items-center">
          <h4 class="m-0 fw-bold text-gray-700 mb-1 fs-3">
            @if (!isLoadingCards) {
            {{ criticitaAlta + criticitaMedia + criticitaBassa }}
            } @else {
            <i class="fa-solid fa-spinner fa-spin text-gray-400"></i>
            }
          </h4>
          <button class="btn btn-sm btn-danger p-0" type="button">
            <i class="bi bi-chevron-down" [class.rotate]="isCriticitaOpen"></i>
          </button>

          @if(isCriticitaOpen){
          <ul class="dropdown-menu list show" (click)="$event.stopPropagation()">
            <li>
              <a class="dropdown-item d-block" href="#" (click)="filterByCriticita('alta', $event)">
                <div class="d-flex align-items-center">
                  <i class="bi bi-exclamation-triangle-fill text-danger me-2 fs-5"></i>
                  <small class="text-gray-500">Alta criticità ({{ criticitaAlta }})</small>
                </div>
                <div class="progress mt-2" role="progressbar">
                  <div class="progress-bar bg-danger" [style.width.%]="getCriticitaPercentages().alta">
                    {{ getCriticitaPercentages().alta }}%
                  </div>
                </div>
              </a>
            </li>

            <li>
              <a class="dropdown-item d-block" href="#" (click)="filterByCriticita('media', $event)">
                <div class="d-flex align-items-center">
                  <i class="bi bi-exclamation-circle-fill text-warning me-2 fs-5"></i>
                  <small class="text-gray-500">Media criticità ({{ criticitaMedia }})</small>
                </div>
                <div class="progress mt-2" role="progressbar">
                  <div class="progress-bar bg-warning" [style.width.%]="getCriticitaPercentages().media">
                    {{ getCriticitaPercentages().media }}%
                  </div>
                </div>
              </a>
            </li>

            <li>
              <a class="dropdown-item d-block" href="#" (click)="filterByCriticita('bassa', $event)">
                <div class="d-flex align-items-center">
                  <i class="bi bi-check-circle-fill text-success me-2 fs-5"></i>
                  <small class="text-gray-500">Bassa criticità ({{ criticitaBassa }})</small>
                </div>
                <div class="progress mt-2" role="progressbar">
                  <div class="progress-bar bg-success" [style.width.%]="getCriticitaPercentages().bassa">
                    {{ getCriticitaPercentages().bassa }}%
                  </div>
                </div>
              </a>
            </li>
          </ul>
          }
        </div>
      </div>

      <small class="m-0 uppercase text-gray-500 font-bold text-sm">Criticità</small>
    </div>
  </div>
</div>
</div>
</div>
</div>